module.exports = __webpack_public_path__ + "img/sm-2022-12-14_13-01-08.4ead7c8e.jpg";